import { render, staticRenderFns } from "./LoginFormInvira.vue?vue&type=template&id=2e0a3804&"
import script from "./LoginFormInvira.vue?vue&type=script&lang=js&"
export * from "./LoginFormInvira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports